import * as Yup from 'yup';
import {ConfigurationSchema} from '~/modules/Clients/models/Configuration';

export interface GlobalConfig {
    config: string;
}

export const defaultGlobalConfig: GlobalConfig = {
    config: '{}'
};

export const GlobalConfigurationSchema = Yup.object().shape<GlobalConfig>({
    config: ConfigurationSchema('config')
});
